module.exports = __webpack_public_path__ + "static/img/avatar.c8bb8fb9.png";